'use strict'
import { request } from '../../plugins/http'

export default async (factoryUserId) => {
    return await request.get('/notificacao',{params:{factoryUserId}})
}